import { render, staticRenderFns } from "./scheduler.vue?vue&type=template&id=38b8c766&scoped=true&"
import script from "./scheduler.vue?vue&type=script&lang=js&"
export * from "./scheduler.vue?vue&type=script&lang=js&"
import style0 from "./scheduler.vue?vue&type=style&index=0&id=38b8c766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8c766",
  null
  
)

component.options.__file = "scheduler.vue"
export default component.exports